import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import i18n from "./i18n"; // ✅ i18n init olunur
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// ✅ İlk dəfə girəndə localStorage-da dil yoxdursa AZ yaz və dərhal tətbiq et
if (!localStorage.getItem("i18nextLng")) {
  localStorage.setItem("i18nextLng", "az");
  i18n.changeLanguage("az");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
